import { stegaClean } from "@sanity/client/stega";

export const sanitizeString = (str) => {
  return str.replace(/[^\x20-\x7E]/g, '')
}
export const clean = (data: string): string => {
  return stegaClean(data); // Preform the data cleaning logic here
}